import { useEffect, useState } from "react";
import { SiteShell, useFlash } from "@ziolo/ui";
import { AuthCards } from "./components/AuthCards.js";
import { BugReportDialog } from "./components/BugReportDialog.js";
import { SupportDialog } from "./components/SupportDialog.js";
import { SurveysPanel } from "./components/SurveysPanel.js";
import { HubPage } from "./pages/HubPage.js";
import { BlackjackPage } from "./pages/BlackjackPage.js";
import { KoloPage } from "./pages/KoloPage.js";
import { NotFoundPage } from "./pages/NotFoundPage.js";
import { PasjansPage } from "./pages/PasjansPage.js";
import { PokerPage } from "./pages/PokerPage.js";
import { KoniePage } from "./pages/KoniePage.js";
import { RuletkaPage } from "./pages/RuletkaPage.js";
import { KebabPage } from "./pages/KebabPage.js";
import { SudokuPage } from "./pages/SudokuPage.js";
import { WordlePage } from "./pages/WordlePage.js";
import { KartyPage } from "./pages/KartyPage.js";
import { MaszynyPage } from "./pages/MaszynyPage.js";
import { EightballPage } from "./pages/EightballPage.js";
import { BottleClickerPage } from "./pages/BottleClickerPage.js";
import { Game2048Page } from "./pages/Game2048Page.js";
import { AdminPage } from "./pages/AdminPage.js";
import { CookiesPage } from "./pages/CookiesPage.js";
import { usePathname } from "./lib/path.js";
import { useSession } from "./session/SessionProvider.js";

const TITLES: Record<string, string> = {
  "/": "zioło.eu",
  "/pasjans": "Pasjans · zioło.eu",
  "/kolo": "Koło fortuny · zioło.eu",
  "/blackjack": "Blackjack · zioło.eu",
  "/ruletka": "Ruletka · zioło.eu",
  "/poker": "Poker · zioło.eu",
  "/konie": "Konie · zioło.eu",
  "/kebab": "Kebab tracker · zioło.eu",
  "/sudoku": "Sudoku · zioło.eu",
  "/wordle": "Polskie Wordle · zioło.eu",
  "/karty": "Karty · zioło.eu",
  "/maszyny": "Maszyny · zioło.eu",
  "/8ball": "8ball · zioło.eu",
  "/bottle-clicker": "Bottle clicker · zioło.eu",
  "/2048": "2048 · zioło.eu",
  "/admin": "Admin · zioło.eu",
  "/polityka-cookies": "Polityka cookies · zioło.eu",
};

export function App() {
  const { user, restoring, logout } = useSession();
  const { push } = useFlash();
  const path = usePathname();
  const isHub = path === "/";
  const [bugOpen, setBugOpen] = useState(false);
  const [supportOpen, setSupportOpen] = useState(false);

  useEffect(() => {
    document.title = TITLES[path] ?? "zioło.eu";
  }, [path]);

  useEffect(() => {
    if (path !== "/sklep") return;
    window.history.replaceState({}, "", "/blackjack");
    window.dispatchEvent(new PopStateEvent("popstate"));
  }, [path]);

  const main =
    path === "/" ? (
      <HubPage />
    ) : path === "/pasjans" ? (
      <PasjansPage />
    ) : path === "/kolo" ? (
      <KoloPage />
    ) : path === "/blackjack" || path === "/sklep" ? (
      <BlackjackPage />
    ) : path === "/ruletka" ? (
      <RuletkaPage />
    ) : path === "/poker" ? (
      <PokerPage />
    ) : path === "/konie" ? (
      <KoniePage />
    ) : path === "/kebab" ? (
      <KebabPage />
    ) : path === "/sudoku" ? (
      <SudokuPage />
    ) : path === "/wordle" ? (
      <WordlePage />
    ) : path === "/karty" ? (
      <KartyPage />
    ) : path === "/maszyny" ? (
      <MaszynyPage />
    ) : path === "/8ball" ? (
      <EightballPage />
    ) : path === "/bottle-clicker" ? (
      <BottleClickerPage />
    ) : path === "/2048" ? (
      <Game2048Page />
    ) : path === "/admin" ? (
      <AdminPage />
    ) : path === "/polityka-cookies" ? (
      <CookiesPage />
    ) : (
      <NotFoundPage />
    );

  return (
    <SiteShell
      user={user}
      adminHref={user?.role === "admin" ? "/admin" : undefined}
      onLogout={() => {
        void logout().then(() => push("Wylogowano", "info"));
      }}
      header={!restoring && !user ? <AuthCards /> : null}
      sidebar={isHub ? <SurveysPanel /> : null}
      footerExtra={
        <>
          <button type="button" className="z-footer__link" onClick={() => setSupportOpen(true)}>
            Postaw piwo
          </button>
          <span className="z-footer__sep" aria-hidden="true">
            ·
          </span>
          <button type="button" className="z-footer__link" onClick={() => setBugOpen(true)}>
            Zgłoś buga
          </button>
        </>
      }
    >
      {main}
      {supportOpen ? <SupportDialog onClose={() => setSupportOpen(false)} /> : null}
      {bugOpen ? <BugReportDialog page={path} onClose={() => setBugOpen(false)} /> : null}
    </SiteShell>
  );
}
